<template>
    <div class="monitorTask">
        <IconDesc class="question" :iconDesc="iconDesc"></IconDesc>
        <v-search
            :formContent="formContent"
            :SearchForm="SearchForm"
            :inline="true"
            :optareBtn="optareBtn"
            @resetFn="resetFn"
            @searchFn="getListFn"
            @confirmFn="getListFn"
            @AddFn="AddFn"
            @DelFn="DelFn"
            @runFn="runFn"
            @stopFn="stopFn"
        >
        </v-search>

        <div class="componentPage">
            <tableTask
                :tableData="tableData"
                :customerArray="customerArray"
                :loading="loading"
                @choozeTableFn="choozeTableFn"
                @statusChangeFn="statusChangeFn"
                @delFn="delFn"
                @triggerFn="triggerFn"
                @detailFn="detailFn"
            />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart" :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <AddDetailEditDialog
            ref="add"
            :isShow.sync="isShow"
            :isEdit.sync="isEdit"
            :customerArray="customerArray"
            :title="title"
            :optate="optate"
            :detailObj="detailObj"
            :statusArray="statusArray"
            :contentArray="contentArray"
            :unitArray="unitArray"
        />
    </div>
</template>

<script>
import { taskList, taskDetail, taskDelete, taskContent, taskOnce, taskRun, taskStop } from '@/api/modules/task.js';
import mixinForm from '@/utils/formMixins.js';
import publicMixin from '@/utils/public.js';
import getRange from '@/utils/getRange.js';

import tableTask from './Table.vue';
import AddDetailEditDialog from './AddDetailEditDialog.vue';
import IconDesc from '@/components/IconDesc/IconDesc.vue';
export default {
    mixins: [mixinForm, publicMixin, getRange],
    components: {
        tableTask,
        AddDetailEditDialog,
        IconDesc
    },
    data() {
        return {
            iconDesc: [
                {
                    title: $t($t('integration.detection_task_status')),
                    type: 'detectionTask'
                }
            ],
            SearchForm: {
                status: null,
                scopeId: null,
                taskName: null
            },
            formContent: [
                {
                    id: 1,
                    text: 'public.status',
                    type: 'select',
                    paramsName: 'status',
                    selectParam: [
                        {
                            id: 1,
                            icon: 'el-icon-video-play',
                            value: 1,
                            label: $t('integration.running')
                        },
                        {
                            id: 2,
                            icon: 'el-icon-video-pause',
                            value: 0,
                            label: this.$t('public.stop')
                        }
                    ],
                    isChooze: true
                },
                {
                    id: 2,
                    text: 'public.table_scope',
                    type: 'select',
                    paramsName: 'scopeId',
                    selectParam: [],
                    isChooze: false
                },
                {
                    id: 3,
                    text: $t('public.task'),
                    type: 'input',
                    paramsName: 'taskName',
                    isChooze: false
                }
            ],
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'buttonTitle.Add1',
                    method: 'AddFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'buttonTitle.Delete',
                    method: 'DelFn'
                },
                {
                    id: 3,
                    icon: '',
                    vHas: ['delRange'],
                    text: $t('integration.running'),
                    method: 'runFn'
                },
                {
                    id: 4,
                    icon: '',
                    vHas: ['delRange'],
                    text: this.$t('public.stop'),
                    method: 'stopFn'
                }
            ],
            statusArray: [],
            customerArray: [],
            contentArray: [],
            unitArray: [],
            choozeTable: [],
            isEdit: true,
            optate: 'add',
            detailObj: {}
        };
    },
    created() {
        if (this.$store.state.type === 3 || this.$store.state.type === 2) {
            this.getRangeFn();
        } else {
            this.formContent.splice(1, 1);
        }
        this.getTaskStatusFn();
    },
    methods: {
        getTaskStatusFn() {
            this.shareParamFn({ code: 'task_detection_status', type: 0 }).then(({ result }) => {
                this.statusArray = result;
                this.formContent[0].selectParam = result.map(item => ({
                    value: item.code,
                    label: item.name,
                    icon: item.code === '1' ? 'el-icon-video-play' : 'el-icon-video-pause'
                }));
            });
        },

        getRangeFn() {
            this.getRange('scope', 1).then(({ result }) => {
                // 过滤掉 All 选项（id=-1, code=global_all），检测任务必须选具体企业
                this.customerArray = result.filter(item => item.id !== '-1' && item.id !== -1 && item.code !== 'global_all');
                this.formContent[1].selectParam = this.customerArray.map(item => ({
                    value: item.id,
                    label: item.name
                }));
            });
        },
        resetFn() {
            this.SearchForm = {
                status: null,
                scopeId: null,
                taskName: null,
                iDisplayStart: 0,
                iDisplayLength: 15
            };
            this.getListFn();
        },
        getListFn() {
            this.loading = true;
            taskList(this.SearchForm)
                .then(({ result, pageInfo }) => {
                    this.tableData = result;
                    this.total = pageInfo.total;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        AddFn() {
            this.isShow = true;
            this.isEdit = true;
            this.optate = 'add';
            this.title = $t('integration.new_task');
            this.$nextTick(() => {
                this.$refs['add'].clearValidate();
                (this.$refs['add'].dioForm = {
                    taskName: '',
                    scopeId: '',
                    status: '0',
                    taskContentId: 1,
                    interval: '',
                    intervalUnit: '0'
                }),
                    (this.$refs['add'].dioForm.scopeId = this.customerArray[0].id);
            });
            this.getContentUnit();
        },
        /** 获取内容和单位 */
        getContentUnit() {
            let P1 = taskContent();
            let P2 = this.shareParamFn({ code: 'detection_interval', type: 0 });
            Promise.all([P1, P2]).then(res => {
                this.contentArray = res[0].result;
                this.unitArray = res[1].result.map(item => ({
                    code: item.code,
                    label: this.$t('task.' + item.content)
                }));
            });
        },
        choozeTableFn(array) {
            this.choozeTable = array;
        },
        DelFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            console.info(this.choozeTable);
            let isDel = true;
            this.choozeTable.map(val => {
                if (val.status == 1) {
                    isDel = false;
                }
            });
            if (!isDel) {
                return this.$message.warning(this.$t('messageTitle.runCheckTaskNotToDel'));
            }
            let ids = this.choozeTable.map(item => item.id);
            this.TODOTIPFN(ids, taskDelete);
        },
        runFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let ids = this.choozeTable.map(item => item.id);
            this.TODOTIPFN(ids, taskRun);
        },
        stopFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let ids = this.choozeTable.map(item => item.id);
            this.TODOTIPFN(ids, taskStop);
        },
        statusChangeFn(row) {
            this.TODOTIPFN([row.id], row.status === 1 ? taskStop : taskRun);
        },
        delFn(row) {
            this.TODOTIPFN([row.id], taskDelete);
        },
        triggerFn(row) {
            this.TODOTIPFN({ id: row.id }, taskOnce);
        },
        detailFn(row) {
            this.isShow = true;
            this.isEdit = false;
            this.optate = 'detail';
            this.title = `[${row.taskName}] ${$t('public.details')}`;
            this.$nextTick(() => {
                this.$refs['add'].clearValidate();
            });
            this.httpDetailFn(row.id);
            this.getContentUnit();
        },

        httpDetailFn(id) {
            taskDetail({ id }).then(({ result }) => {
                result.scopeId = result.scopeId + '';
                this.detailObj = result;
            });
        },

        TODOTIPFN(param, httpUrl) {
            this.$confirm(this.$t('integration.are_you_sure_about_this_operation?'))
                .then(() => {
                    httpUrl(param).then(({ result }) => {
                        if (result === 200) {
                            this.getListFn();
                            this.$message.success($t('integration.success'));
                        } else {
                            this.$message.error($t('integration.fail'));
                        }
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style lang="scss">
.monitorTask {
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
    .question {
        height: 16px;
        position: absolute;
        right: 20px;
        top: 38px;
    }
}
</style>
